import { Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";
import type { SuggestionOptions } from "@tiptap/suggestion";
import type { ChipOption } from "components/editor/email-editor";

export interface ChatVariableOptions {
  suggestion: Partial<SuggestionOptions<ChipOption>>;
}

/**
 * Lightweight TipTap extension that registers a `{{` suggestion plugin
 * for the chat input. Unlike the email editor's VariableChip, this does
 * NOT define a node — selection inserts the resolved literal value as
 * plain text via the suggestion's `command` handler.
 */
export const ChatVariable = Extension.create<ChatVariableOptions>({
  name: "chatVariable",

  addOptions() {
    return {
      suggestion: {},
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});
